import { createContext, useContext, useReducer  } from 'react'
import { Roles } from '../utilities/constants'

const CharactersContext = createContext()

const useCharacters = () => {
    const context = useContext(CharactersContext)

    if (context === undefined) throw new Error('useCharacters must be used within a CharactersProvider')

    return context
}

const CharactersProvider = ({ children }) => {
    const reducer = (state, { action, payload }) => {
        switch (action) {
            case 'user': {
                return { ...state, user: payload }
            }
            case 'select': {
                return { ...state, previous: state.current, current: payload }
            }
            case 'server': {
                return { ...state, server: {
                    list: payload,
                    pending: payload.filter((character) => character.acceptedServer === undefined || character.acceptedServer === null),
                    rejected: payload.filter((character) => character.acceptedServer === false),
                    accepted: payload.filter((character) => character.acceptedServer),
                    pendingAlliance: payload.filter((character) => character.acceptedAlliance === undefined || character.acceptedAlliance === null),
                    rejectedAlliance: payload.filter((character) => character.acceptedAlliance === false),
                    acceptedAlliance: payload.filter((character) => character.acceptedAlliance),
                } }
            }
            case 'alliance': {
                return { ...state, alliance: {
                    list: payload,
                    pending: payload.filter((character) => character.acceptedAlliance === undefined || character.acceptedAlliance === null),
                    rejected: payload.filter((character) => character.acceptedAlliance === false),
                    accepted: payload.filter((character) => character.acceptedAlliance),
                } }
            }
        }
    }

    const [$state, dispatch] = useReducer(reducer, {})

    const user = (characters) => dispatch({ action: 'user', payload: characters })
    const select = (character) => dispatch({ action: 'select', payload: character })
    const server = (characters) => dispatch({ action: 'server', payload: characters })
    const alliance = (characters) => dispatch({ action: 'alliance', payload: characters })
    const authorized = (roles) => Array.isArray(roles) ? roles.some((roleName) => $state.current?.role?.name === roleName) : ($state.current?.role?.name === roles)

    return (
        <CharactersContext.Provider value={{ $state, user, server, alliance, select, authorized }}>
            {children}
        </CharactersContext.Provider>
    )
}

export { useCharacters, CharactersProvider }